var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListpreselectionbenf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "58.000000pt",
    height: "66.000000pt",
    viewBox: "0 0 58.000000 66.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,66.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 320 l0 -280 200 0 200 0 0 280 0 280 -200 0 -200 0 0 -280z m380 0 l0 -260 -180 0 -180 0 0 260 0 260 180 0 180 0 0 -260z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 493 c-21 -22 -29 -24 -41 -14 -23 19 -28 -4 -5 -25 19 -17 21 -17 55 18 20 19 32 38 27 41 -5 3 -21 -6 -36 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 470 c0 -6 30 -10 70 -10 40 0 70 4 70 10 0 6 -30 10 -70 10 -40 0 -70 -4 -70 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 395 c-15 -16 -30 -23 -42 -19 -22 7 -24 -9 -2 -27 13 -10 21 -7 51 23 19 20 31 38 26 41 -6 4 -21 -5 -33 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 370 c0 -6 30 -10 70 -10 40 0 70 4 70 10 0 6 -30 10 -70 10 -40 0 -70 -4 -70 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 295 c-15 -16 -30 -23 -42 -19 -23 7 -24 -18 -2 -37 13 -11 21 -7 52 24 25 25 33 40 26 47 -7 7 -18 2 -34 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 265 c0 -12 14 -15 70 -15 56 0 70 3 70 15 0 12 -14 15 -70 15 -56 0 -70 -3 -70 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 183 c-22 -21 -30 -24 -42 -14 -22 19 -28 -4 -6 -24 20 -18 21 -18 55 15 34 33 43 50 27 50 -4 0 -19 -12 -34 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 160 c0 -6 30 -10 70 -10 40 0 70 4 70 10 0 6 -30 10 -70 10 -40 0 -70 -4 -70 -10z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListpreselectionbenf);
export default __webpack_public_path__ + "static/media/listpreselectionbenf.7b59aac6237a86e24d2543ea8222af3a.svg";
export { ForwardRef as ReactComponent };